<template>
  <div ref="chartContainer" style="width: 100%; height: 100%;"></div>
</template>

<script setup>
import * as echarts from 'echarts';
import { onMounted, ref } from 'vue';
const chartContainer = ref(null); // 创建一个对DOM元素的引用

let angle = 0;//角度，用来做简单的动画效果的

var color = ['#E5913C', '#885DFF', '#2DF3E2', '#F5D527', '#0BA0FF'];

var legend = [['种植业', '畜牧业', '渔业'], ['林业','副业']];

var seriesData = [
  { name: '种植业', value: 60 },
    { name: '畜牧业', value: 10 },
    { name: '渔业', value: 15 },
    
    { name: '林业', value: 23 },
    { name: '副业', value: 10 }
];

var option = {
    color: color,
    legend: [{
      itemHeight: 6,
      itemWidth: 15,
      icon: "rect",
      orient: 'vertical',
      top: '30%',
      left: '0 ',
      textStyle: {
         align: 'left',
         verticalAlign: 'middle',
         rich: {
            name: {
               color: '#ffffff',
               fontSize:12,
            },
            value: {
               color: '#ffffff',
               fontSize: 12,
            },
            rate: {
               color: '#ffffff',
               fontSize: 12,
            },
         },
      },
      data: legend[0],
      formatter: (name) => {
         if (seriesData.length) {
            const item = seriesData.filter((item) => item.name === name)[0];
            // return `{name|${name}：}{rate| ${item.value}%} {value| |} {value| ${item.value}}`;
            return `{name|${name}：}{rate|${item.value}%}`;
         }
      },
   },{
      itemHeight: 6,
      itemWidth: 15,
      icon: "rect",
      orient: 'vertical',
      top: 'center',
      right:'0',
      textStyle: {
         align: 'left',
         verticalAlign: 'middle',
         rich: {
            name: {
               color: '#ffffff',
               fontSize:12,
            },
            value: {
               color: '#ffffff',
               fontSize: 12,
            },
            rate: {
               color: '#ffffff',
               fontSize: 12,
            },
         },
      },
      data: legend[1],
      formatter: (name) => {
         if (seriesData.length) {
            const item = seriesData.filter((item) => item.name === name)[0];
            // return `{name|${name}：}{rate| ${item.value}%} {value| |} {value| ${item.value}}`;
            return `{name|${name}：}{rate|${item.value}%}`;
         }
      },
   }],
    series: [{
        name: "ring5",
        type: 'custom',
        coordinateSystem: "none",
        renderItem: function (params, api) {
            return {
                type: 'arc',
                shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.7,
                    startAngle: (0 + angle) * Math.PI / 180,
                    endAngle: (90 + angle) * Math.PI / 180
                },
                style: {
                    stroke: "#0CD3DB",
                    fill: "transparent",
                    lineWidth: 1.5
                },
                silent: true
            };
        },
        data: [0]
    }, {
        name: "ring5",
        type: 'custom',
        coordinateSystem: "none",
        renderItem: function (params, api) {
            return {
                type: 'arc',
                shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.7,
                    startAngle: (180 + angle) * Math.PI / 180,
                    endAngle: (270 + angle) * Math.PI / 180
                },
                style: {
                    stroke: "#0CD3DB",
                    fill: "transparent",
                    lineWidth: 1.5
                },
                silent: true
            };
        },
        data: [0]
    }, {
        name: "ring5",
        type: 'custom',
        coordinateSystem: "none",
        renderItem: function (params, api) {
            return {
                type: 'arc',
                shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() /2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.8,
                    startAngle: (270 + -angle) * Math.PI / 180,
                    endAngle: (40 + -angle) * Math.PI / 180
                },
                style: {
                    stroke: "#0CD3DB",
                    fill: "transparent",
                    lineWidth: 1.5
                },
                silent: true
            };
        },
        data: [0]
    }, {
        name: "ring5",
        type: 'custom',
        coordinateSystem: "none",
        renderItem: function (params, api) {
            return {
                type: 'arc',
                shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.8,
                    startAngle: (90 + -angle) * Math.PI / 180,
                    endAngle: (220 + -angle) * Math.PI / 180
                },
                style: {
                    stroke: "#0CD3DB",
                    fill: "transparent",
                    lineWidth: 1.5
                },
                silent: true
            };
        },
        data: [0]
    }, {
        name: "ring5",
        type: 'custom',
        coordinateSystem: "none",
        renderItem: function (params, api) {
            let x0 = api.getWidth() / 2;
            let y0 = api.getHeight() / 2;
            let r = Math.min(api.getWidth(), api.getHeight()) / 2 * 0.8;
            let point = getCirlPoint(x0, y0, r, (90 + -angle))
            return {
                type: 'circle',
                shape: {
                    cx: point.x,
                    cy: point.y,
                    r: 2
                },
                style: {
                    stroke: "#0CD3DB",//粉
                    fill: "#0CD3DB"
                },
                silent: true
            };
        },
        data: [0]
    }, {
        name: "ring5",  //绿点
        type: 'custom',
        coordinateSystem: "none",
        renderItem: function (params, api) {
            let x0 = api.getWidth() / 2;
            let y0 = api.getHeight() / 2;
            let r = Math.min(api.getWidth(), api.getHeight()) / 2 * 0.8;
            let point = getCirlPoint(x0, y0, r, (270 + -angle))
            return {
                type: 'circle',
                shape: {
                    cx: point.x,
                    cy: point.y,
                    r: 2
                },
                style: {
                    stroke: "#0CD3DB",      //绿
                    fill: "#0CD3DB"
                },
                silent: true
            };
        },
        data: [0]
    }, {
         name: '占比',
         type: 'pie',
         center: ['50%', '50%'],
         radius: ['35%', '60%'],
         label: {
            normal: {
               show: false,
               position: 'center',
               formatter: '{value|{c}}\n{label|{b}}',
            },

         },
         labelLine: {
            show: false,
            length: 0,
            length2: 0,
         },
         itemStyle: {//间隔
            normal: {
               borderWidth: 0,
               borderColor: '#050e31',
            },
         },
         data: seriesData,
      },
    ]
};
//获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
function getCirlPoint(x0, y0, r, angle) {
    let x1 = x0 + r * Math.cos(angle * Math.PI / 180)
    let y1 = y0 + r * Math.sin(angle * Math.PI / 180)
    return {
        x: x1,
        y: y1
    }
}
function draw() {
  var myChart = echarts.init(chartContainer.value);
    angle = angle + 3
    myChart.setOption(option, true)
}


onMounted(() => {
  setInterval(function () {
    //用setInterval做动画感觉有问题
    draw()
}, 120);

});

</script>